var ChatButton = xClass("ChatButton", HomeSceneButton)

ChatButton.prototype.ctor = function () {
    let self = this
    var str  = "世界聊天"//getText("shopname.out.buyban")
    HomeSceneButton.prototype.ctor.call(self, str, "special_prop/chat.png")
    
    // self.bg.setOpacity(255 * 0.7)
    self.bg.setVisible(false)
    self.text.setVisible(false)
}

ChatButton.prototype.onCick = function () {

    let minigameCenter = window.minigameCenter
    
    //let offscreenCanvas = window.offscreenCanvas
    //let chatTop = 50;
    //let devicePixelRatio = wx.getSystemInfoSync();
    let sysInfo = wx.getSystemInfoSync().system.toLowerCase()
    let index = sysInfo.substr(7)
    console.log(index)
    console.log(wx.getSystemInfoSync().system)
    if(minigameCenter) {
        minigameCenter.open('');
    }
    DCAssist.dc4NewIconPanel("world_chat")
    DCAssist.userTrack("user_click", "click_world_chat");

}

module.exports = ChatButton
